import type { ReactNode } from 'react';
import React from 'react';
import { Redirect, useParams } from 'react-router';
import { generatePath } from 'react-router-dom';

import {
  useGetRenderingsQuery,
  useJobSharedRenderingsQuery,
} from 'src/shared/graphql/generated';
import { Route } from 'src/shared/route';

const RedirectWithSession = ({ children }: { children: ReactNode }) => {
  const { shareToken } = useParams<{ shareToken: string }>();
  const { data: sharedData } = useJobSharedRenderingsQuery({
    variables: { shareToken },
  });
  const jobId = sharedData?.jobSharedRenderings?.id;
  const renderings = sharedData?.jobSharedRenderings?.hiDefRenderings ?? [];
  const renderingId = renderings[0]?.id;

  const { data } = useGetRenderingsQuery({
    skip: typeof jobId !== 'number',
    variables: { id: jobId as number },
    context: { skipRedirect: true },
  });

  const hasJobMatch = (data?.jobs?.results ?? []).some(
    job =>
      job?.id === jobId &&
      (job?.hiDefRenderings || []).some(
        rendering => rendering.id === renderingId,
      ),
  );

  if (
    hasJobMatch &&
    typeof jobId === 'number' &&
    typeof renderingId === 'number'
  ) {
    const redirectPath = generatePath(Route.RENDERINGS_HUB.path, {
      jobId,
      renderingId,
    });
    return <Redirect to={redirectPath} />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export { RedirectWithSession };
